import { render, staticRenderFns } from "./AddFirstFairPayPlanProposalWizard.vue?vue&type=template&id=a3fb72ec&scoped=true"
import script from "./AddFirstFairPayPlanProposalWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./AddFirstFairPayPlanProposalWizard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddFirstFairPayPlanProposalWizard.vue?vue&type=style&index=0&id=a3fb72ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fb72ec",
  null
  
)

export default component.exports